import * as yup from 'yup'

export const createRoleSchema = yup.object().shape({
    role: yup.string().required('Chưa nhập tên vai trò'),
    resources: yup
        .object()
        .test(
            'at-least-one-permission',
            'Vui lòng chọn ít nhất một quyền',
            (value) => {
                if (!value) return false
                const hasPermissions = Object.values(value).some(
                    (scopes: any) => Array.isArray(scopes) && scopes.length > 0
                )
                return hasPermissions
            }
        ),
})

export const updateRoleSchema = yup.object().shape({
    resources: yup
        .object()
        .test(
            'at-least-one-permission',
            'Vui lòng chọn ít nhất một quyền',
            (value) => {
                if (!value) return false
                const hasPermissions = Object.values(value).some(
                    (scopes: any) => Array.isArray(scopes) && scopes.length > 0
                )
                return hasPermissions
            }
        ),
})
